import Vuex from "vuex";
import { benefitEstimatorV2Module } from "@benefit-estimator/store/modules/benefitEstimatorV2Module";
import { globalModule } from "@/plugins/store/globalModule";
import { quoteModule } from "@/plugins/store/quoteModule";

export default new Vuex.Store({
  modules: {
    benefitEstimatorV2Module,
    globalModule,
    quoteModule,
  },
});
